module.exports = __webpack_public_path__ + "img/phone-top-bar.7ba7b823.png";